var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"className":"text-left"}},[_c('v-col',{attrs:{"cols":"3"}},[_vm._v(" The report goes here ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }